import { useState, useCallback } from 'react'
import { useQuery } from 'react-query'
import useCurrentUser from '../use-current-user'
import messagesFetchService from '../../services/api/messages-fetch'
import { get } from 'lodash'
import useMessagesCache from '../use-messages-cache'


const useMessages = ({
    pageSize = 10,
    searchString,
    box = 'in',
}) => {
    const { keys: cacheKeys } = useMessagesCache()
    const [ offset, setOffset ] = useState(0)
    const { currentUser } = useCurrentUser()
    const key = box === 'in' ? cacheKeys.INBOX_PAGINATED : cacheKeys.OUTBOX_PAGINATED
    const recipientId = box === 'in' ? get(currentUser, 'id') : undefined
    const authorId = box === 'out' ? get(currentUser, 'id') : undefined
    const fetcher = useCallback(() => {
        return messagesFetchService({ limit: pageSize, offset, authorId, recipientId, searchString })
    }, [authorId, recipientId, offset, pageSize, searchString])
    const { data, isLoading } = useQuery(key, fetcher, { enabled: Boolean(currentUser) })

    return {
        isLoading,
        messages: get(data, 'items', []),
        total: get(data, 'total', 0),
        offset,
        setOffset
    }
}

export default useMessages
